export const heroTranslations = {
    en: {
        line1: "Explore",
        line2: "Dream",
        line3: "Discover",
        quote1start: "Twenty",
        quote1mid: " years from now, you will be more disappointed by the things you didn't do than those you did.",
        quote2start: "So",
        quote2mid: " throw off the bowlines.",
        quote2sail: " Sail",
        quote2sailEnd: " away from safe harbor.",
        quote2catch: " Catch",
        quote2catchEnd: " the wind in your sails."
    },
    hr: {
        line1: "Istražite",
        line2: "Sanjajte",
        line3: "Otkrijte",
        quote1start: "Dvadeset",
        quote1mid: " godina od sada, više ćete žaliti za stvarima koje niste učinili nego za onima koje jeste.",
        quote2start: "Zato",
        quote2mid: " otpustite sidrene konope.",
        quote2sail: " Isplovite",
        quote2sailEnd: " iz sigurne luke.",
        quote2catch: " Uhvatite",
        quote2catchEnd: " vjetar u jedra."
    },
    es: {
        line1: "Explora",
        line2: "Sueña",
        line3: "Descubre",
        quote1start: "Dentro de veinte",
        quote1mid: " años lamentarás más las cosas que no hiciste que las que hiciste.",
        quote2start: "Así que",
        quote2mid: " suelta las amarras.",
        quote2sail: " Navega",
        quote2sailEnd: " lejos del puerto seguro.",
        quote2catch: " Atrapa",
        quote2catchEnd: " el viento en tus velas."
    },
    it: {
        line1: "Esplora",
        line2: "Sogna",
        line3: "Scopri",
        quote1start: "Fra vent'anni",
        quote1mid: " sarai più deluso dalle cose che non hai fatto che da quelle che hai fatto.",
        quote2start: "Quindi",
        quote2mid: " larga gli ormeggi.",
        quote2sail: " Salpa",
        quote2sailEnd: " dal porto sicuro.",
        quote2catch: " Cattura",
        quote2catchEnd: " il vento nelle tue vele."
    },
    pl: {
        line1: "Odkryj",
        line2: "Marz",
        line3: "Poznaj",
        quote1start: "Za dwadzieścia",
        quote1mid: " lat będziesz bardziej żałować rzeczy, których nie zrobiłeś, niż tych, które zrobiłeś.",
        quote2start: "Więc",
        quote2mid: " odwiąż cumy.",
        quote2sail: " Odpłyń",
        quote2sailEnd: " z bezpiecznej przystani.",
        quote2catch: " Złap",
        quote2catchEnd: " wiatr w żagle."
    },
    fr: {
        line1: "Explorez",
        line2: "Rêvez",
        line3: "Découvrez",
        quote1start: "Dans vingt",
        quote1mid: " ans, vous serez plus déçu par les choses que vous n'avez pas faites que par celles que vous avez faites.",
        quote2start: "Alors",
        quote2mid: " largez les amarres.",
        quote2sail: " Naviguez",
        quote2sailEnd: " loin du port sûr.",
        quote2catch: " Attrapez",
        quote2catchEnd: " le vent dans vos voiles."
    },
    de: {
        line1: "Entdecken",
        line2: "Träumen",
        line3: "Erleben",
        quote1start: "In zwanzig",
        quote1mid: " Jahren wirst du mehr über die Dinge enttäuscht sein, die du nicht getan hast, als über die, die du getan hast.",
        quote2start: "Also",
        quote2mid: " wirf die Leinen los.",
        quote2sail: " Segel",
        quote2sailEnd: " fort aus dem sicheren Hafen.",
        quote2catch: " Fang",
        quote2catchEnd: " den Wind in deinen Segeln."
    }
};